<template>
	<div id="job">
		<div banner>
			<div class="container">
				<div>工作机会</div>
			</div>
		</div>
		<div class="container">
			<div>
				<h5>工作机会</h5>
				<div>
					<div content>
						<p>
							如果您：
							<br />对工作怀有激情，而不是将工作仅仅作为谋生的手段；
							<br />懂得团队合作的重要性，并能够与他人共担艰辛，共享成功；
							<br />心怀远大的目标，但不忽视繁琐的细节；
							<br />美信咨询将能够为您提供一个施展才能的平台。
						</p>
						<p>在美信咨询，员工有机会得到良好的培训。美信咨询通过各种各样的培训以帮助新加入的员工尽快适应新的环境，如新员工培训、周五咨询顾问沙龙、部门业务培训、年度集中培训、年度考核总结大会等。此外，还经常有不定期的专题讲座、网上业务讨论等。通过多层次、内容广泛、形式灵活的培训活动，各年级的咨询顾问随时置身于持续的学习状态中。</p>
						<p>在紧张工作的另一面，美信咨询是温馨的家庭：每月，美信咨询会邀请本月过生日的同事在一起，共同庆祝生日；任何同事需要帮助，只要一封邮件，很快会收到热情的回复。为促进同事之间的交流，美信咨询北京在设计新办公室时，特地辟出40多平米作为咖啡室。</p>
					</div>
					<div image></div>
				</div>
			</div>
			<div>
				<div :active="open.a">
					<h5 @click="open.a = !open.a">
						IPO上市前市场业务经理
						<span :class="'fa ' + (open.a ? 'fa-minus' : 'fa-plus')"></span>
					</h5>
					<div>
						<p>
							<strong>
								<span style="font-size: 14px">职位描述：</span>
							</strong>
							<br />1、与全国各个省份的潜在拟上市企业进行沟通关于企业融资需求、上市进度等情况；
							<br />2、渠道开拓：各行业协会、各省地方金融办、发展和改革主管部门，了解拟上市企业信息；
							<br />3、掌握监测工作流程、负责收集、整理企业资料；
							<br />4、电话调研、沟通，电话约访，寻找潜在客户；
							<br />5、详细的记录企业情况，及时更新总结并反馈给部门领导；
							<br />6、研究评估个企业的投资价值和细分市场地位等。
						</p>
						<p>
							<strong>
								<span style="font-size: 14px">职位要求：</span>
							</strong>
							<br />1、大专以上学历，性别不限，年龄在22-30岁；
							<br />2、口齿清晰，普通话流利，良好的沟通能力；
							<br />3、具备较高的工作热情，敢于挑战自我；
							<br />4、头脑灵活、思维敏捷，具备良好的抗压能力和处事应变能力；
							<br />5、踏实、努力，有工作责任心，具有较强的团队合作精神；
							<br />6、有电话销售、证券行业工作、协会工作、金融机构经验者优先
						</p>
					</div>
				</div>
				<div :active="open.b">
					<h5 @click="open.b = !open.b">
						高级财务分析师、会计师（侧重于企业上市募投前后的经济效益分析）
						<span :class="'fa ' + (open.b ? 'fa-minus' : 'fa-plus')"></span>
					</h5>
					<div>
						<p>
							<strong>
								<span style="font-size: 14px">职位描述：</span>
							</strong>
							<br />针对准备上市的企业，对其募投项目进行经济效益测算
						</p>
						<p>
							<strong>
								<span style="font-size: 14px">职位要求：</span>
							</strong>
							<br />1、会计专业毕业，通过会计、财务、审计方面的考试
							<br />2、做过两年以上的财务分析或会计、审计工作
							<br />3、曾在准备上市的企业工作过的优先，在工程预算部门及经济效益分析部门工作过的优先
							<br />4、可适应长期出差
						</p>
					</div>
				</div>
			</div>
			<div>
				<div :active="open.c">
					<h5 @click="open.c = !open.c">
						IPO上市前细分市场（行业分析/研究）咨询顾问
						<span :class="'fa ' + (open.c ? 'fa-minus' : 'fa-plus')"></span>
					</h5>
					<div>
						<p>
							<strong>
								<span style="font-size: 14px">职位描述：</span>
							</strong>
							<br />1、为各个细分市场的准备上市的企业提供细分市场研究及咨询服务。
							<br />2、针对某市场区域做深入调研，准确定位市场现状、动态，预测并制作市场模型。
							<br />3、研究分析相关行业的基本面，掌握行业及公司的新动态；
							<br />4、对行业进行深入研究，准确判断行业发展趋势；
							<br />5、跟踪研究相关产业链上价值形成、核心价值分布情况，并转化为研究成果；
							<br />6、分析行业发展历程及现状，预测行业未来发展趋势，并撰写研究报告。
							<br />7、行业细分市场信息收集，包含行业相关法规政策、市场发展动态、行业技术水平、行业重点企业及竞争情况等；
							<br />8、对所负责行业细分市场进行价值研究，撰写和更新专业细分市场研究报告
							<br />9、按照证监会的1号准则及28号准则出具细分市场调研报告，深度分析其所处行业的基本情况。深度分析其在行业中的竞争地位，包括准上市企业的市场占有率、近三年的变化情况及未来变化趋势，主要竞争对手的简要情况等。
							<br />10、准上市企业应根据重要性原则深度分析主营业务的具体情况，包括：
							<br />&nbsp; （一）主要产品或服务的用途；
							<br />&nbsp; （二）主要产品的工艺流程图或服务的流程图；
							<br />&nbsp; （三）主要经营模式，包括采购模式、生产模式和销售模式；
							<br />11、准上市企业应当遵循重要性原则，按顺序深度分析可能直接或间接对准上市企业生产经营状况、财务状况和持续盈利能力产生重大不利影响的所有因素。
							<br />12、准上市企业应针对自身的实际情况，充分、准确、具体地深度分析相关风险因素。
							<br />13、准上市企业应对所深度分析的风险因素做定量分析，无法进行定量分析的，应有针对性地作出定性深度分析。
							<br />14、编写招股说明业务与技术章节
						</p>
						<p>
							<strong>
								<span style="font-size: 14px">职位要求：</span>
							</strong>
							<br />1、本科及以上学历，研究生优先。
							<br />2、具有一定的行业研究经历或相关技术背景，了解行业的关键竞争要素、公司的投资价值、行业风险等；
							<br />3、有良好的财务、金融基础知识，熟悉各种研究方法，数据处理能力突出，复合背景尤佳；
							<br />4、有责任心、思维严谨、较强的抗压能力、出色的沟通能力和学习能力；
							<br />5、较强的逻辑分析能力，掌握数据分析方法，文笔好。
							<br />6、具有证券从业资格、熟悉上市流程者优先。
							<br />7、可适应长期出差。
							<br />8、提供有竞争力的薪资制度。
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				open: {
					a: false,
					b: false,
					c: false,
				}
			};
		}
	}
</script>
